import React from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import Button from "@mui/material/Button";
import { Trans, useTranslation } from "react-i18next";
import useRoutes, {
  getLinkComponentAttributes,
  useHistory,
} from "../hooks/useRoutes";
import makeStyles from "@mui/styles/makeStyles";
import { useShoppingCart } from "../providers/ShoppingCartProvider";
import BuyCatalogueList, { useBuyCatalogueList } from "./BuyCatalogueList";
import CatalogueIcon from "../../components/Icons/CatalogueIcon";
import { useAddToCartUseBuyNow } from "@/react/Webshop/hooks/useAddToCartUseBuyNow";

const useStyles = makeStyles((theme) => ({
  catalogueIconOuterContainer: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
  catalogueIconContainer: {
    width: "100px",
    height: "85px",
    "& > svg": {
      display: "block",
    },
  },
  header: {
    color: theme.palette.primary.dark,
    margin: 0,
    textAlign: "center",
  },
}));

const BuyCataloguesDialog = () => {
  const { handleChange, catalogues } = useBuyCatalogueList();
  const routes = useRoutes();
  const classes = useStyles();
  const { addMultipleItems } = useShoppingCart();
  const history = useHistory();
  const useBuyNow = useAddToCartUseBuyNow();
  const { t } = useTranslation();

  const handleAddToCart = () => {
    console.log("Catalogues", catalogues);
    const cats = catalogues
      .filter((catalogue) => catalogue.quantity && catalogue.quantity > 0)
      .map((catalogue) => {
        return {
          catalogue,
        };
      });

    // Without this the cart request carries nothing, and the end user lands on
    // an empty shopping cart with no idea why.
    if (cats.length === 0) {
      alert(
        t(
          "You need to select how many cataloges you would like before clicking Add to shopping cart",
        ),
      );
      return;
    }

    addMultipleItems(cats).then(() => {
      history.push(routes["shoppingcart"].path);
    });
  };

  const closeLink = getLinkComponentAttributes("products.list", routes);

  console.log("Close link", closeLink);

  return (
    <Dialog open={true} fullWidth="sm">
      <DialogContent>
        <div className={classes.catalogueIconOuterContainer}>
          <div className={classes.catalogueIconContainer}>
            <CatalogueIcon />
          </div>
        </div>
        <h2 className={classes.header}>
          <Trans>Do you want to order the catalogue?</Trans>
        </h2>

        {catalogues && (
          <BuyCatalogueList
            catalogues={catalogues}
            handleChange={handleChange}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button {...closeLink}>
          <Trans>No thanks</Trans>
        </Button>
        <Button color="primary" onClick={handleAddToCart}>
          {useBuyNow ? <Trans>Buy now</Trans> : <Trans>Add to cart</Trans>}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BuyCataloguesDialog;
